//
import { List as ImmutableList, Record } from 'immutable';

import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

/*
 * KNOWN KEYS
 *
 *  'bankTransactions' - array of transactionsTypes.CashFlowTransaction types
 */

export const mkClipboardStore = Record({
  clipboard: ImmutableList(),
});

const mkClipboardItemInternal = Record({
  key: undefined,
  data: undefined,
  id: null,
  createdOn: null,
});

export const mkClipboardItem = (defaults) =>
  mkClipboardItemInternal({
    id: uuidv4(),
    createdOn: DateTime.local().toISO(),
    ...defaults,
  });
